const _ = (data: any) => {
  const products: any = [];
  const product = {
    name: data.productNumber,
    id: data.productNumber,
    price:
      data.price !== null && data.price !== undefined
        ? data.price
        : data.unitPrice
        ? data.unitPrice
        : null,
    brand: data.manufacturerCode || '',
    quantity: data.quantity
  };
  products.push(product);
  return products;
};

export default (
  data: any,
  event: string,
  listName?: string,
  labelName?: string
) => {
  const itemsList = _(data);
  const actionField = { action: 'add' };

  if (listName) {
    actionField['list'] = listName;
  }

  if (labelName) {
    actionField['label'] = labelName;
  }

  return {
    event,
    ecommerce: {
      add: {
        actionField,
        products: itemsList
      }
    }
  };
};
